import { css } from 'styled-components';

const sizes = {
  desktop: 960,
  tablet: 640,
  mobile: 320
};

// iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((accumulator, label) => {
  const emSize = sizes[label] / 16;
  accumulator[label] = (...args) => css`
    @media (min-width: ${emSize}em) {
      ${css(...args)};
    }
  `;
  return accumulator;
}, {});

// target IE10+
export const ie = (...args) => css`
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    ${css(...args)};
  }
`;



// WEBPACK FOOTER //
// ./src/utils/style.js